import { gtmOnclick } from "./gtmOnclick";

export const gtmOnclickDniContinuar = () => {
  gtmOnclick({
    seccion: "Formulario",
    subZona: "Datos Personales",
    tipoElemento: "Botón",
    tipoEvento: "Clic",
    valor: "Continuar",
  });
};

export const gtmOnclickCompletarDatos = (isHappy) => {
  gtmOnclick({
    seccion: `Completar Datos - ${isHappy ? 'Feliz' : 'No Feliz'}`,
    subZona: "Datos Personales",
    tipoElemento: "Modal",
    tipoEvento: "Visualizar",
    valor: `Completar Datos - ${isHappy ? 'Feliz' : 'No Feliz'}`,
  });
};

export const gtmOnclickContinuar = (isHappy) => {
  gtmOnclick({
    seccion: `Completar Datos - ${isHappy ? 'Feliz' : 'No Feliz'}`,
    subZona: "Datos Personales",
    tipoElemento: "Botón",
    tipoEvento: "Clic",
    valor: "Continuar",
  });
};
